//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpInlineSelect',
  props: {
    value: { type: null, required: true },
    options: { type: Array, required: true, default: () => [] },
    attached: { type: Boolean, default: false },
  },
  methods: {
    selectOption(option) {
      this.$emit('input', option.value);
      this.$emit('change', option.value);
    },
  },
};
